import React from 'react';
import { ShieldCheckIcon } from '@heroicons/react/24/outline';
import ModuleAccessManagement from '../../components/ModuleAccessManagement';
import technicalMaintenanceApi from '../../api/technicalMaintenanceApi';

const TechnicalMaintenanceAccessPage = () => (
  <ModuleAccessManagement
    title="Teknik Bakım Erişimi"
    description="Denetim modülü altındaki Teknik Bakım ekranlarını görebilecek kullanıcıları seçin."
    api={technicalMaintenanceApi}
    accent="sky"
    icon={ShieldCheckIcon}
  />
);

export default TechnicalMaintenanceAccessPage;
